import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { AssistanceUtilitiesWithNavigate } from "../../../AssistanceUtilities";
import InputComponent from "../../../components/InputComponent";
import { useAuth } from "../../../context/AuthContext";
import { useAvailableModulesContext } from "../../../context/AvailableModulesContext";
import Toast from "../../../helpers/Toast";
import { Utilities } from "../../../helpers/Utilities";
import { AssistanceDTO } from "../../../models/Assistance/AssistanceDTO";
import { AssistanceUpdateDTO } from "../../../models/Assistance/AssistanceUpdateDTO";
import { GetAssistanceByClientEquipmentDTO } from "../../../models/Assistance/GetAssistanceByClientEquipment";
import { AssistanceAuxiliaryEquipmentDTO } from "../../../models/AssistanceAuxiliaryEquipments/AssistanceAuxiliaryEquipmentDTO";
import { SearchAuxiliaryEquipmentByDescriptionDTO } from "../../../models/AuxiliaryEquipment/SearchAuxiliaryEquipmentByDescriptionDTO";
import { EquipmentDTO } from "../../../models/Equipment/EquipmentDTO";
import { ProjectDTO } from "../../../models/Project/ProjectDTO";
import { TimeHistoryDTO } from "../../../models/TimeHistory/TimeHistoryDTO";
import { AssistanceService } from "../../../services/AssistanceService";
import { AuxiliaryEquipmentService } from "../../../services/AuxiliaryEquipmentService";
import { EquipmentService } from "../../../services/EquipmentService"; // Adicionado import
import ButtonComponent from "../../ButtonComponent";
import CheckboxComponent from "../../CheckboxComponent";
import ClientEquipmentBidirecional from "../../ClientEquipmentBidirecional/ClientEquipmentBidirecional";
import SearchSelectComponent from "../../SearchSelectComponent";
import SelectComponent from "../../SelectComponent";
import { RenderCountersInputs } from "../RenderCountersInputs";

type AssistanceEditComponentType = {
    assistance: AssistanceDTO;
    isLoadingAssistance: boolean;
    setAssistance: Function;
};

export type SelectItemsProps = {
    label: string;
    value: string;
};

export default function AssistanceEditA({ assistance, isLoadingAssistance, setAssistance }: AssistanceEditComponentType) {

    const assistanceService = new AssistanceService();
    const equipmentService = new EquipmentService(); // Adicionado service do equipamento

    const { preferedView } = useAuth();
    const auxiliaryEquipmentsService = new AuxiliaryEquipmentService();

    // equipamentos auxiliares
    const [auxiliaryEquipments, setAuxiliaryEquipments] = useState<SelectItemsProps[]>([]);
    const [selectedAuxiliaryEquipments, setSelectedAuxiliaryEquipments] = useState<string>("");

    //obras
    const [projectSelected, setProjectSelected] = useState<SelectItemsProps | null>(null);
    const [project, setProject] = useState<ProjectDTO>({} as ProjectDTO);
    const [isSearchProjectLoading, setIsSearchProjectLoading] = useState<boolean>(false);

    // tipo assistencia
    const [selectedAssistanceType, setSelectedAssistanceType] = useState<string>(Utilities.LoadParameterFromURLQuery("assistanceType", "string", ""));
    const [assistanceTypesComponent, setAssistanceTypesComponent] = useState<SelectItemsProps[]>([]);

    // props para novo componente
    const [isActiveProjectModule, setIsActiveProjectModule] = useState<boolean>(false);
    const [clientSelected, setClientSelected] = useState<SelectItemsProps | null>(null);
    const [serialNumberSelected, setSerialNumberSelected] = useState<SelectItemsProps | null>(null);
    const [equipment, setEquipment] = useState<EquipmentDTO>({} as EquipmentDTO);
    const [isSearchEquipmentLoading, setIsSearchEquipmentLoading] = useState<boolean>(false);
    const [carPlateSelected, setCarPlateSelected] = useState<SelectItemsProps | null>(null);

    const [serviceFromEquipment, setServiceFromEquipment] = useState<boolean>(false);
    const [currentService, setCurrentService] = useState<string>("");

    const [isComplete, setIsComplete] = useState<boolean>(false);
    const [isEditButtonLoading, setIsEditButtonLoading] = useState<boolean>(false);

    //módulos ativos
    const { availableModules, assistanceTypes, counterOptions } = useAvailableModulesContext();
    const [isActiveAuxiliaryEquipments, setIsActiveAuxiliaryEquipments] = useState<boolean>(false);
    const [isActiveProfitabilityModule, setIsActiveProfitabilityModule] = useState<boolean>(false);
    const [isActiveCountersModule, setIsActiveCountersModule] = useState<boolean>(false);
    const [isActiveCarPlate, setIsActiveCarPlate] = useState<boolean>(false);
    const [isActiveErpEquipments, setIsActiveErpEquipments] = useState<boolean>(false);
    const [isActiveChangeClientInEquipmentAndAssistance, setIsActiveChangeClientInEquipmentAndAssistance] = useState<boolean>(false);
    const [isActivePriorityModule, setIsActivePriorityModule] = useState<boolean>(false);
    const [isActiveReincidenceModule, setIsActiveReincidenceModule] = useState<boolean>(false);
    const [isActiveErpSupportModule, setIsActiveErpSupportModule] = useState<boolean>(false);
    const [isActivePicketModule, setIsActivePicketModule] = useState<boolean>(false);

    const [incompleteAssistanceSelected, setIncompleteAssistanceSelected] = useState<SelectItemsProps | null>(null);

    const [selectedAssistancePriority, setSelectedAssistancePriority] = useState<string>("");
    const [assistancePriority, setAssistancePriority] = useState<SelectItemsProps[]>([]);

    // Separate state variables for date and time
    const [assistanceDate, setAssistanceDate] = useState<string>("");
    const [assistanceTime, setAssistanceTime] = useState<string>("");

    const navigate = useNavigate();
    const assistanceUtilities = AssistanceUtilitiesWithNavigate(navigate);

    const getEquipmentData = async (equipmentId: string) => {
        try {
            const response = await equipmentService.GetByIdErp(equipmentId);
            if (response.success && response.obj) {
                return response.obj;
            }
        } catch (error) {
            console.error("Erro ao buscar dados do equipamento:", error);
        }
        return null;
    };
    const checkAndSetService = async () => {
        if (assistance?.equipment?.erpId) {
            const assistanceService = assistance.service;

            if (!assistanceService || assistanceService.trim() === "") {
                const equipmentData = await getEquipmentData(assistance.equipment.erpId);
                if (equipmentData && equipmentData.service) {
                    setCurrentService(equipmentData.service);
                    setServiceFromEquipment(true);
                } else {
                    setCurrentService("");
                    setServiceFromEquipment(false);
                }
            } else {
                setCurrentService(assistanceService);
                setServiceFromEquipment(false);
            }
        }
    };
    useEffect(() => {
        checkAndSetService();
    }, [assistance?.equipment?.erpId, assistance?.id]); // Dependências para reexecutar quando necessário

    // Initialize and update date/time state when assistance changes
    useEffect(() => {
        if (assistance?.date) {
            setAssistanceDate(Utilities.formatDateYYYYMMDD(new Date(assistance.date)));
            setAssistanceTime(Utilities.GetTimeFromDateTime(new Date(assistance.date)));
        }
    }, [assistance?.date]);

    useEffect(() => {
        if (availableModules.includes("IsActiveAuxiliaryEquipments")) {
            setIsActiveAuxiliaryEquipments(true);
        }
        if (availableModules.includes("ProfitabilitySage50cIsActiveProfitabilityModule")) {
            setIsActiveProfitabilityModule(true);
        }
        if (availableModules.includes("ProjectSage50cIsActiveProjectModule")) {
            setIsActiveProjectModule(true);
        }
        if (availableModules.includes("IsActiveCountersModule")) {
            setIsActiveCountersModule(true);
        }
        if (availableModules.includes("IsActiveCarPlate")) {
            setIsActiveCarPlate(true);
        }
        if (availableModules.includes("IsActiveErpEquipments")) {
            setIsActiveErpEquipments(true);
        }
        if (availableModules.includes("IsActiveChangeClientInEquipmentAndAssistance")) {
            setIsActiveChangeClientInEquipmentAndAssistance(true);
        }
        if (availableModules.includes("IsActivePriorityModule")) {
            setIsActivePriorityModule(true);
        }
        if (availableModules.includes("IsActiveReincidenceModule")) {
            setIsActiveReincidenceModule(true);
        }
        if (availableModules.includes("IsActiveErpSupportModule")) {
            setIsActiveErpSupportModule(true);
        }
        if (availableModules.includes("IsPicketActive")) {
            setIsActivePicketModule(true);
        }
    }, [availableModules]);

    useEffect(() => {
        if (assistance && assistance.assistanceAuxiliaryEquipments) {
            const localAssistanceAuxiliaryEquipments = assistance.assistanceAuxiliaryEquipments.map(element => ({
                value: element.erpId,
                label: `${element.description} - ${element.serialNumber}`,
            }));
            const assistanceAuxiliaryEquipmentsString = localAssistanceAuxiliaryEquipments.map(item => item.value).join(",");
            setSelectedAuxiliaryEquipments(assistanceAuxiliaryEquipmentsString);
        }
    }, [assistance]);

    useEffect(() => {
        GetAssistancesByClientEquipmentState(assistance.erpDocType ? assistance.erpDocType : '')
    }, [assistance.incompleteAssistanceId]);

    //passar dados para inputs dinamicos
    const [timeHistory, setTimeHistory] = useState<TimeHistoryDTO>(assistance.timeHistory || {});
    useEffect(() => {
        if (assistance.timeHistory) {
            setTimeHistory(assistance.timeHistory);
        }
    }, [assistance.timeHistory]);

    // ao atualizar valor dos inputs, levar valor para processo de editar assistência
    useEffect(() => {
        setAssistance((prev: AssistanceDTO) => ({ ...prev, timeHistory }));
    }, [timeHistory]);

    const getAuxiliaryEquipments = async (value: string) => {
        const list: SelectItemsProps[] = [];
        var data: SearchAuxiliaryEquipmentByDescriptionDTO = {
            description: value,
        };
        var response = await auxiliaryEquipmentsService.GetAuxiliaryEquipmentsByDescription(data);

        if (response.success === false) {
            Toast.Show("error", response.message);
            return;
        }

        response.obj.forEach((element) => {
            var item: SelectItemsProps = {
                value: element.erpId,
                label: `${element.description} - ${element.serialNumber}`,
            };
            list.push(item);
        });

        setAuxiliaryEquipments(list);
    };

    useEffect(() => {
        if (isActiveAuxiliaryEquipments) {
            getAuxiliaryEquipments("");
        }
    }, [isActiveAuxiliaryEquipments]);

    const calcSizeByItems = isActiveErpEquipments === false && isActiveChangeClientInEquipmentAndAssistance === true && assistanceUtilities.IsValidAssistanceStatusToChangeClientAndEquipment(assistance.status) &&
        assistance.hasExecutions === false ? 9 : 12;

    const updateEquipmentService = async (newService: string, equipmentErpId: string) => {
        try {
            const equipmentResponse = await equipmentService.GetByIdErp(equipmentErpId);
            if (equipmentResponse.success && equipmentResponse.obj) {
                const equipmentData = equipmentResponse.obj;


                const updateData = {
                    id: equipmentData.id,
                    erpId: equipmentData.erpId,
                    name: equipmentData.name,
                    carPlate: equipmentData.carPlate,
                    serialNumber: equipmentData.serialNumber,
                    brand: equipmentData.brand,
                    model: equipmentData.model,
                    clientErpId: equipmentData.client.erpId,
                    service: newService,

                };

                const updateResponse = await equipmentService.Edit(updateData);
                return updateResponse;
            }
        } catch (error) {
            console.error("Erro ao atualizar service do equipamento:", error);
            return { success: false, message: "Erro ao atualizar service do equipamento" };
        }
        return { success: false, message: "Equipamento não encontrado" };
    };

    const editAssistance = async () => {
        const selectedAuxiliaryEquipmentsArray = selectedAuxiliaryEquipments
            ?.split(',')
            .map((erpId: string) => {
                const selectedEquipment = auxiliaryEquipments?.find(
                    (auxEquip) => auxEquip.value === erpId
                );
                return selectedEquipment
                    ? new AssistanceAuxiliaryEquipmentDTO(erpId, selectedEquipment.label, "")
                    : null;
            })
            .filter((equipment): equipment is AssistanceAuxiliaryEquipmentDTO => equipment !== null);// remover os nulos

        setIsEditButtonLoading(true);

        if (serviceFromEquipment && assistance?.equipment?.erpId && currentService !== (assistance.equipment as any)?.originalService) {
            const equipmentUpdateResponse = await updateEquipmentService(currentService, assistance.equipment.erpId);
            if (!equipmentUpdateResponse.success) {
                Toast.Show("error", intl.formatMessage({ id: "Screens.Equipment.Service.Error" }));
                setIsEditButtonLoading(false);
                return;
            }
        }

        // Combine date and time into a single Date object
        const combinedDateTime = new Date(`${assistanceDate}T${assistanceTime}`);

        var data: AssistanceUpdateDTO = {
            id: assistance.id,
            date: combinedDateTime,
            counter1: assistance.timeHistory.counter1 || 0,
            counter2: assistance.timeHistory.counter2 || 0,
            counter3: assistance.timeHistory.counter3 || 0,
            counter4: assistance.timeHistory.counter4 || 0,
            counter5: assistance.timeHistory.counter5 || 0,
            counter6: assistance.timeHistory.counter6 || 0,
            projectErpId: projectSelected == null ? null : project.erpId,
            clientErpId: project ? (project.client ? project.client.erpId : assistance.client?.erpId) : null,
            assistanceType: (selectedAssistanceType === null || selectedAssistanceType === "" || selectedAssistanceType === undefined) ? assistance.assistanceType : selectedAssistanceType,
            clientContact: assistance.clientContact ?? null,
            incompleteAssistanceId: incompleteAssistanceSelected?.value != undefined ? Number(incompleteAssistanceSelected.value) : assistance.incompleteAssistanceId,
            priority: selectedAssistancePriority ? Number(selectedAssistancePriority) : assistance.priority,
            service: serviceFromEquipment ? (assistance.service || "") : currentService,
            workshopInternalNumber: assistance.workshopInternalNumber,
            picket: assistance.picket
        };

        var response = await assistanceService.Edit(data);
        if (response.success === false) {
            Toast.Show("error", response.message);
            setIsEditButtonLoading(false);
            return;
        }

        // Após escolher nova obra, que irá alterar o cliente, não estava a atualizar os componentes, com isto vai atualizar
        setAssistance({
            ...assistance,
            projectErpId: projectSelected?.label,
            client: {
                name: project?.client?.name ?? assistance.client?.name,
                id: project?.client?.id ?? assistance.client?.id
            },
            /* assistanceAuxiliaryEquipments: data.assistanceAuxiliaryEquipments, */
        });

        Toast.Show("success", intl.formatMessage({ id: "Screens.Assistances.Info.Success" }));
        setIsEditButtonLoading(false);
    };

    const handleServiceChange = (newService: string) => {
        setCurrentService(newService);
        if (!serviceFromEquipment) {
            setAssistance({ ...assistance!, service: newService });
        }
    };

    useEffect(() => {
        setIsComplete(!assistance.userCanEdit);
    }, [assistance]);

    const intl = useIntl();

    const GetAssistancesByClientEquipmentState = async (valueAssistance: string): Promise<SelectItemsProps[]> => {
        var assistanceToFilter: GetAssistanceByClientEquipmentDTO =
        {
            valueToFilter: valueAssistance,
            clientErpId: assistance.client?.id,
            clientEquipmentErpId: assistance.equipment?.id
        };

        const response = await assistanceService.GetAssistancesByClientEquipmentFinalState(assistanceToFilter);

        if (response.success === false || response.obj === null) {
            Toast.Show("error", response.message);
            return [];
        }

        if (assistance.incompleteAssistanceId != null) {
            const incompleteAssistance = response.obj?.find(element =>
                element.id = Number(assistance.incompleteAssistanceId),
            )
            if (incompleteAssistance != null) {
                setIncompleteAssistanceSelected({ value: incompleteAssistance.id.toString(), label: `${incompleteAssistance.erpDocType} ${incompleteAssistance.erpSerie} ${incompleteAssistance.erpNumDoc}` })
            }
        }

        const list: SelectItemsProps[] = [];
        response.obj?.forEach((element) => {
            var item: SelectItemsProps = {
                value: `${element.id}`,
                label: `${element.erpDocType} ${element.erpSerie} ${element.erpNumDoc}`
            };
            list.push(item);
        });

        return list;
    };

    //obter prioridades da assistência
    const getPriorities = async () => {
        const list: SelectItemsProps[] = [];
        const priorityList: number[] = [1, 2, 3];

        priorityList.forEach((priority) => {
            const item: SelectItemsProps = {
                value: priority.toString(),
                label: priority.toString(),
            };
            list.push(item);
        });

        setAssistancePriority(list);
    };

    useEffect(() => {
        getPriorities();
    }, []);

    //obter tipo de assistencia
    const getAssistanceTypes = async () => {
        const list: SelectItemsProps[] = [];

        assistanceTypes.forEach((element) => {
            var item: SelectItemsProps = {
                value: element,
                label: element,
            };
            list.push(item);
        });

        setAssistanceTypesComponent(list);
    };

    useEffect(() => {
        getAssistanceTypes();
    }, []);

    return (
        <>
            <label style={{ margin: "0px", padding: "13px" }}>
                <b>Informação Geral</b>
            </label>

            <Row style={{ margin: "0px", padding: "0px", alignItems: "flex-end", alignContent: "flex-end" }}>
                <SelectComponent
                    xl={9}
                    lg={9}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{ width: "100%", height: "43px" }}
                    label={"Tipo de Assistência"}
                    selectedItemValue={(selectedAssistanceType === null || selectedAssistanceType === "" || selectedAssistanceType === undefined) ? assistance.assistanceType : selectedAssistanceType}
                    items={assistanceTypesComponent}
                    onChange={(t: string) => {
                        setSelectedAssistanceType(t);
                    }}
                    blockItem={isComplete}
                    showLoadingSkeleton={isLoadingAssistance || isEditButtonLoading || isSearchProjectLoading}
                />

                {isActivePicketModule &&
                    <Col xl={3} lg={3} md={12} sm={12} xs={12}>
                        <CheckboxComponent
                            checked={assistance.picket ?? false}
                            disabled={isComplete}
                            label={intl.formatMessage({ id: "Screens.AssistanceEdit.Picket" })}
                            style={{ marginBottom: "8px" }}
                            onChange={(checked: boolean) => {
                                setAssistance({ ...assistance!, picket: checked });
                            }}
                        />
                    </Col>
                }
            </Row>

            <Row style={{ margin: "0px", padding: "0px", alignItems: "flex-end", alignContent: "flex-end" }}>
                <InputComponent
                    xl={4}
                    lg={4}
                    md={4}
                    sm={4}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"text"}
                    value={assistance?.clientContact ?? null}
                    label={"Contacto do Cliente"}
                    readOnly={isComplete}
                    showLoadingSkeleton={isLoadingAssistance || isEditButtonLoading || isSearchProjectLoading}
                    onChange={(t: string) => {
                        setAssistance({ ...assistance!, clientContact: t });
                    }}
                />
            </Row>

            <Row style={{ margin: "0px", padding: "0px", alignItems: "flex-end", alignContent: "flex-end" }}>
                <ClientEquipmentBidirecional
                    isActiveProjectModule={isActiveProjectModule}
                    projectSelected={projectSelected}
                    clientSelected={clientSelected}
                    setClientSelected={setClientSelected}
                    serialNumberSelected={serialNumberSelected}
                    setSerialNumberSelected={setSerialNumberSelected}
                    equipment={equipment}
                    setEquipment={setEquipment}
                    isSearchEquipmentLoading={isLoadingAssistance || isEditButtonLoading || isSearchProjectLoading}
                    setIsSearchEquipmentLoading={setIsSearchEquipmentLoading}
                    clientErpId={assistance?.client?.erpId}
                    equipmentErpId={assistance?.equipment?.erpId}
                    isActiveSearchByCarPlate={isActiveCarPlate}
                    carPlateSelected={carPlateSelected}
                    setCarPlateSelected={setCarPlateSelected}
                    assistance={assistance}
                    setAssistance={setAssistance}
                    isDisabled={true}
                    isActiveChangeClientInEquipmentAndAssistance={isActiveChangeClientInEquipmentAndAssistance}
                    isActiveErpEquipments={isActiveErpEquipments}
                    assistanceHasExecutions={assistance.hasExecutions}
                    assistanceStatus={assistance.status ?? undefined}
                    isValidAssistanceStatusToChangeClientAndEquipment={assistanceUtilities.IsValidAssistanceStatusToChangeClientAndEquipment}
                    assistanceId={assistance?.id}
                />

                <InputComponent
                    xl={4}
                    lg={4}
                    md={4}
                    sm={4}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"text"}
                    value={currentService ?? ""}
                    label={intl.formatMessage({ id: "Screens.Client.Info.Service" })}
                    readOnly={isComplete || isActiveErpSupportModule}
                    showLoadingSkeleton={isLoadingAssistance || isEditButtonLoading}
                    onChange={handleServiceChange}
                />
            </Row>

            <Row style={{ margin: "0px", padding: "0px", alignItems: "flex-end", alignContent: "flex-end" }}>
                <InputComponent
                    xl={3}
                    lg={3}
                    md={3}
                    sm={3}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"date"}
                    value={assistanceDate}
                    label={"Data"}
                    readOnly={isComplete}
                    showLoadingSkeleton={isLoadingAssistance || isEditButtonLoading || isSearchProjectLoading}
                    onChange={(t: string) => {
                        setAssistanceDate(t);
                    }}
                />

                <InputComponent
                    xl={2}
                    lg={2}
                    md={2}
                    sm={2}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"time"}
                    value={assistanceTime}
                    label={"Hora"}
                    readOnly={isComplete}
                    showLoadingSkeleton={isLoadingAssistance || isEditButtonLoading || isSearchProjectLoading}
                    onChange={(t: string) => {
                        setAssistanceTime(t);
                    }}
                />
            </Row>

            {/* Estado 2 - Contadores */}
            {isActiveCountersModule && !isActiveErpSupportModule && (
                <>
                    <label style={{ margin: "0px", padding: "13px", fontWeight: "bold" }}>
                        {intl.formatMessage({ id: "Screens.AssistanceEditB.CountersTitle" })}
                    </label>
                    <Row style={{ margin: "0px", padding: "0px" }}>
                        {RenderCountersInputs(counterOptions, timeHistory, setTimeHistory, (isComplete || isLoadingAssistance || isEditButtonLoading || isSearchProjectLoading))}
                    </Row>
                </>
            )}

            {isActivePriorityModule &&
                <Row style={{ margin: "0px", padding: "0px", alignItems: "flex-end", alignContent: "flex-end" }}>
                    <SelectComponent
                        xl={12}
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        style={{ width: "100%", height: "43px" }}
                        label={"Prioridade"}
                        selectedItemValue={(selectedAssistancePriority === null || selectedAssistancePriority === "" || selectedAssistancePriority === undefined) ? assistance.priority?.toString() ?? "" : selectedAssistancePriority}
                        items={assistancePriority}
                        onChange={(t: string) => {
                            setSelectedAssistancePriority(t);
                        }}
                        blockItem={isComplete}
                        showLoadingSkeleton={isLoadingAssistance || isEditButtonLoading || isSearchProjectLoading}
                    />
                </Row>
            }

            {isActiveReincidenceModule &&
                <>
                    <label style={{ margin: "0px", padding: "13px", fontWeight: "bold" }}>
                        {intl.formatMessage({ id: "Screens.AssistanceEdit.IncompleteAssistanceTitle" })}
                    </label>
                    <Row style={{ margin: "0px", padding: "0px", alignItems: "flex-end", alignContent: "flex-end" }}>
                        <SearchSelectComponent
                            xl={7}
                            lg={7}
                            md={7}
                            sm={12}
                            xs={12}
                            label={intl.formatMessage({ id: "Screens.AssistanceEdit.IncompleteAssistanceAssigned" })}
                            loadOptions={GetAssistancesByClientEquipmentState}
                            onChange={(e: SelectItemsProps) => {
                                setIncompleteAssistanceSelected(e);
                            }}
                            value={incompleteAssistanceSelected}
                            style={{ width: "100%" }}
                        />

                        <Col xl={5} lg={5} md={5} sm={12} xs={12}>
                            <ButtonComponent
                                style={{ width: "100%", marginBottom: "8px" }}
                                text={intl.formatMessage({ id: "Common.Buttons.NavigateToAssistance" })}
                                onClick={() => assistanceUtilities.NavigateToAssistanceDetails(Number(incompleteAssistanceSelected?.value), preferedView, false, true)}
                            />
                        </Col>
                    </Row>
                </>
            }

            {isComplete || preferedView === "Oficina" ? (
                ""
            ) : (
                <Row style={{ margin: "0px", padding: "0px", justifyContent: "end" }}>
                    <Col xl={3} lg={3} md={3} sm={12} xs={12}>
                        <ButtonComponent
                            style={{ width: "100%", marginTop: "10px" }}
                            text={intl.formatMessage({ id: "AssistanceEditA.Save" })}
                            onClick={() => editAssistance()}
                            disabled={isLoadingAssistance || isEditButtonLoading || isSearchProjectLoading}
                        />
                    </Col>
                </Row>
            )}
        </>
    );
}